import TelephonyLogsPage from "/src/features/administration/telephonyLogs/components/TelephonyLogsPage";

function TelephonyLogsList() {
    return <TelephonyLogsPage />;
}

export default TelephonyLogsList;
